/* eslint-disable react/jsx-props-no-spreading */
import { Box } from '@mui/material';
import { UPDropdownHelperText } from 'components/dropdown/styles';
import { UPInputLabel } from 'components/input/styles';
import { useCallback } from 'react';
import { UPButtonGroupStyled } from './styles';
import { UPGroupButtonProps } from './types';

const UPButtonGroup = (props: UPGroupButtonProps): JSX.Element => {
  const { children, label, required, error, value, onChange, helperText, page, disabled } = props;

  const onChangeValue = useCallback(
    (event: React.MouseEvent<HTMLElement>, newValue: string | null) => {
      onChange(newValue);
    },
    [onChange],
  );

  return (
    <Box>
      {label && (
        <UPInputLabel>
          {label} {required && '*'}
        </UPInputLabel>
      )}
      <UPButtonGroupStyled
        color={error ? 'error' : 'primary'}
        value={value}
        onChange={onChangeValue}
        exclusive
        disabled={disabled}
      >
        {children}
      </UPButtonGroupStyled>
      {error && <UPDropdownHelperText>{helperText}</UPDropdownHelperText>}
    </Box>
  );
};

UPButtonGroup.defaultProps = {
  label: '',
  error: false,
  required: false,
  helperText: '',
};

export default UPButtonGroup;
